// Content blockers ship `||browser-intake-datadoghq.eu^$third-party`, so the browser SDK
// sends through this first-party path and the server forwards the untouched batch.
// https://docs.datadoghq.com/real_user_monitoring/guide/proxy-rum-data/
export const BROWSER_INTAKE_PATH = "/api/client-events"
export const DATADOG_SITE = process.env.NEXT_PUBLIC_DD_SITE || "datadoghq.eu"
const tracks = new Set(["/api/v2/rum", "/api/v2/replay"])

// OpenNext on Workers rebuilds request.url and decodes `&` nested inside the default ddforward
// value, which strips dd-api-key. ddforward carries only the track; SDK parameters stay top level.
export function browserIntakeUrl({ path, parameters }: { path: string; parameters: string }) {
  return `${BROWSER_INTAKE_PATH}?ddforward=${encodeURIComponent(path)}&${parameters}`
}

export async function forwardBrowserIntake(request: Request, site = DATADOG_SITE, transport: typeof fetch = fetch): Promise<Response> {
  const parts = site.split(".")
  const origin = `https://browser-intake-${parts.slice(0, -1).join("-")}.${parts.at(-1)}`
  const parameters = new URL(request.url).searchParams
  const track = parameters.get("ddforward")
  if (!track || !tracks.has(track)) return new Response(null, { status: 404 })
  parameters.delete("ddforward")
  const target = new URL(`${origin}${track}?${parameters}`)
  const headers = new Headers({ "content-type": request.headers.get("content-type") ?? "text/plain" })
  const client = request.headers.get("cf-connecting-ip") ?? request.headers.get("x-forwarded-for")?.split(",")[0].trim()
  if (client) headers.set("x-forwarded-for", client)
  const agent = request.headers.get("user-agent")
  if (agent) headers.set("user-agent", agent)
  const response = await transport(target, { method: "POST", headers, body: await request.arrayBuffer() })
  await response.body?.cancel()
  return new Response(null, { status: response.status })
}
